const WorkExperience = [
    {
        id: 1,
        title: 'Front-End Developer',
        company: 'Adenza',
        yearsActive: '12/2019 - Present',
        information: [
            'Built a reusable React and Tailwind CSS component library, reducing UI development time by 40% across 3 internal products.',
            'Implemented TypeScript and Zod-based validation, reducing production runtime errors by 25%.',
            'Drove REST API contract design with backend teams, enabling sub-200ms response times for critical user-facing features serving 10,000+ active users.',
            'Optimized application performance and maintainability through reusable architecture and modern frontend best practices.',
        ],
    },
    {
        id: 2,
        title: 'Front-End Developer',
        company: 'Genie Soft System Pvt. Ltd.',
        yearsActive: '04/2017 - 11/2019',
        information: [
            `Designed and launched 8 responsive websites and web applications for client and internal products.`,
            `Improved website traffic by 40% and reduced bounce rate by 25% through UX and performance enhancements.`,
            `Reduced development turnaround time by 30% through reusable UI patterns and streamlined workflows.`,
            `Collaborated with stakeholders to convert business requirements into scalable frontend solutions.`,
        ],
    },
    {
        id: 3,
        title: 'Freelance Frontend Developer (Part-time consulting)',
        company: 'Freelancer',
        yearsActive: '2016 – Present',
        information: [
            `Migrated 20+ client projects from WordPress/jQuery to Next.js, reducing average page load times by 45% and improving SEO performance.`,
            `Developed a high-traffic social platform prototype supporting 5,000+ simulated concurrent users using WebSocket-based real-time notifications.`,
            `Maintained and enhanced the Calypso learning platform serving 10,000+ monthly users, increasing engagement by 25% through UI and performance optimization.`,
        ],
    },
    {
        id: 4,
        title: 'Software Engineering',
        company: 'I Direct it Education Institute College',
        yearsActive: '2014 - 2016',
        information: [
            `From 2013 to 2015, I Direct it Education Institute's Software Engineering and Web Developer courses became more popular. More students signed up each year, reaching 100 by 2015. Many students found jobs after finishing, with good placement rates. The institute worked to give students useful computer skills. This period was good for the Software Engineering and Web Developer programs. `,
        ],
    },
    {
        id: 5,
        title: 'Bachelor Of Commerce',
        company: 'University of Mumbai',
        yearsActive: '2013 - 2015',
        information: [
            `'From 2013 to 2015, Mumbai University's Commerce courses got more popular. More students joined each year, reaching 1200 by 2015. Many students got jobs after finishing, with good placement rates. The university worked to give students useful business skills. Being in Mumbai helped students connect with companies. This time was good for the Commerce program.`,
        ],
    },
];

export default WorkExperience;
